import { toast } from 'react-toastify';

import {
  postRequestSupport,
} from '../api/bernabeu';

import {
  helpCenterSlice,
  callTypes
} from "../../redux/reducers/helpCenterSlice";

const { actions } = helpCenterSlice;

const requestCreateRequestSupport = (originId, originType, message) => dispatch => {
  return new Promise((resolve, reject) => {
    dispatch(actions.startCall({ callType: callTypes.action }));

    postRequestSupport({
      origin_id: originId,
      origin_type: originType,
      message: message,
    }).then((response: any) => {
      toast.success('Solicitação enviada!');

      dispatch(actions.requestSupportCreated());

      resolve(true);
    }).catch((error: any) => {
      console.log('requestCreateRequestSupport falhou:');
      console.log({error});

      dispatch(actions.catchError({ error, callType: callTypes.action }));

      reject(false);
    });
  });
}

export {
  requestCreateRequestSupport,
}